import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { isNullOrUndefined } from '@utils/object';
import MaxProductQuantity from '@shopDetails/components/MaxProductQuantity';
import useIsDesktopLayout from '@hooks/useIsDesktopLayout';
import { getDeliveryAmount } from '@shopDetails/utils/plus';
import ShippingAmount from './components/ShippingAmount';
import DeliveryAmount from './components/DeliveryAmount';
import Separator from './components/Separator';
import Container from './components/Container';
import FleetUtilisationIcon from './components/FleetUtilisationIcon';

import PlusTag from '../ShopHeader/components/PlusTag';
import DeliveryContainer from '../Pickup/PickupToggle/Information/Delivery/components/DeliveryContainer';
import Line from './components/Line';

function DeliveryInfo({
  deliveryTime,
  shippingAmount,
  minDeliveryAmount,
  hasCart,
  className,
  showMaxProductQuantity,
  plusSettings,
  useLiveOrderTracking,
}) {
  const isDesktopLayout = useIsDesktopLayout();
  const isFreeShipping = useMemo(() => shippingAmount === 0, [shippingAmount]);
  const plusDeliveryAmount = useMemo(
    () => getDeliveryAmount(shippingAmount, plusSettings),
    [shippingAmount, plusSettings],
  );
  const showPlusTag = useMemo(() => Boolean(plusSettings) && !isFreeShipping, [
    plusSettings,
    isFreeShipping,
  ]);

  if (!hasCart) return null;

  return (
    <Container className={className}>
      <Line>
        {!isNullOrUndefined(deliveryTime) && (
          <span>{deliveryTime.description}</span>
        )}
        {!isNullOrUndefined(shippingAmount) && (
          <>
            {showPlusTag ? (
              <>
                <Separator />
                <DeliveryContainer>
                  <PlusTag
                    desktopMode={isDesktopLayout}
                    finalPricePlus={plusDeliveryAmount}
                    originalPricePlus={shippingAmount}
                  />
                </DeliveryContainer>
              </>
            ) : (
              <>
                <Separator />
                <ShippingAmount shippingAmount={shippingAmount} />
                {useLiveOrderTracking && <FleetUtilisationIcon size="medium" />}
              </>
            )}
            <Separator />
            <DeliveryAmount amount={minDeliveryAmount} />
          </>
        )}
      </Line>

      {showMaxProductQuantity && (
        <Line>
          <MaxProductQuantity />
        </Line>
      )}
    </Container>
  );
}

DeliveryInfo.propTypes = {
  deliveryTime: PropTypes.shape({
    description: PropTypes.string,
  }),
  plusSettings: PropTypes.object,
  shippingAmount: PropTypes.number,
  minDeliveryAmount: PropTypes.number,
  hasCart: PropTypes.bool,
  // from styled components
  className: PropTypes.string,
  showMaxProductQuantity: PropTypes.bool,
  useLiveOrderTracking: PropTypes.bool.isRequired,
};

DeliveryInfo.defaultProps = {
  showMaxProductQuantity: true,
};

export default injectIntl(DeliveryInfo);
